var map = {
	"./en-us/auth.json": 3856,
	"./en-us/general.json": 9526,
	"./es-es/auth.json": 9351,
	"./es-es/general.json": 9643,
	"./pt-br/auth.json": 711,
	"./pt-br/general.json": 2699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4649;